import { PageProps, graphql } from "gatsby";
import React, { useEffect, useState } from "react";
import { ArticleCardList } from "../components/article-card-list";
import { Breadcrumbs } from "../components/breadcrumbs";
import { Button } from "../components/button";
import { Layout } from "../components/layout";
import { notEmpty } from "../utils/utils";

const MainCategoryPage: React.FC<
  PageProps<Queries.MainCategoryQuery, { id: string; subCategoryId?: string }>
> = ({ data, pageContext }) => {
  const [selectedSubcategoryId, setSelectedSubCategoryId] = useState<
    string | null
  >(
    pageContext.subCategoryId ||
      (data.strapiMainCategory &&
        data.strapiMainCategory.sub_categories &&
        data.strapiMainCategory.sub_categories.length)
      ? data.strapiMainCategory?.sub_categories
        ? [0]
          ? data.strapiMainCategory?.sub_categories![0]!.id
          : null
        : null
      : null,
  );
  useEffect(
    () => setSelectedSubCategoryId(pageContext.subCategoryId || null),
    [pageContext.subCategoryId],
  );
  if (!data.strapiMainCategory) return null;
  const selectedSubCategory = data.allStrapiSubCategory.edges
    .map((edge) => edge.node)
    .find((subCategory) => subCategory.id === selectedSubcategoryId);

  const articles = data.allStrapiArticle.edges.map((edge) => edge.node);
  return (
    <Layout noBreadcrumbs>
      <Breadcrumbs mainCategoryId={pageContext.id} />
      <div className="mb-16 flex flex-wrap justify-end">
        {data.allStrapiSubCategory.edges.map(({ node: subCategory }) => {
          if (!subCategory) return null;
          return (
            <Button
              {...{
                key: subCategory.id,
                id: subCategory.id,
                title: subCategory.name,
                url: `/${data.strapiMainCategory?.slug}/${subCategory.slug}`,
                selected: subCategory.id === selectedSubcategoryId,
                target: "_self",
                transparent: true,
              }}
            />
          );
        })}
      </div>

      {articles && (
        <ArticleCardList
          textBlock={selectedSubCategory && selectedSubCategory.text_block}
          articles={articles.filter(notEmpty)}
          showTitleAndDivide={false}
        />
      )}
    </Layout>
  );
};

export default MainCategoryPage;

export const pageQuery = graphql`
  query MainCategory($id: String, $subCategoryId: String) {
    strapiMainCategory(id: { eq: $id }) {
      id
      name
      slug
      description {
        data {
          childrenMarkdownRemark {
            html
          }
        }
      }
      sub_categories {
        id
        slug
        name
        articles_standard_pages {
          rank
          ...ArticleCard
        }
      }
    }
    allStrapiSubCategory(filter: { main_category: { id: { eq: $id } } }) {
      edges {
        node {
          id
          slug
          name
          main_category {
            id
            slug
          }
          text_block {
            data {
              text_block
            }
          }
        }
      }
    }
    allStrapiArticle(
      sort: [{ rank: ASC }, { publishedAt: DESC }]
      filter: {
        sub_category: {
          id: { eq: $subCategoryId }
          main_category: { id: { eq: $id } }
        }
      }
    ) {
      edges {
        node {
          rank
          publishedAt
          ...ArticleCard
        }
      }
    }
  }
`;
